// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__ZQ9h-","DesktopOnly":"Toolbar_DesktopOnly__KDhU1"};